define('fukit/view/block/steps.block.view',['require','exports','module','underscore','uikit/uikit','../../helpers/factory'],function(require, exports, module) {
  //prettier-ignore
  var _       = require('underscore'),
      UIKit   = require('uikit/uikit'),
      Factory = require('../../helpers/factory');

  var StepsBlockView = UIKit.Steps.extend({
    className: UIKit.Steps.prototype.className + ' ordered',
    options: _.extend({}, UIKit.Steps.prototype.options, {
      fluid: true,
    }),
  });

  module.exports = StepsBlockView;
});

